import { useState } from "react";
import { ReactComponent as ArrowIcon } from "@assets/images/main/services/arrow-top-right.svg";
import classes from "./Accordion.module.scss";

type Props = {
  title: string;
  subtitle: string;
  description: string;
  price: string;
};

const Accordion = ({ title, subtitle, price, description }: Props) => {
  const [isActive, setIsActive] = useState(false);

  return (
    <div
      className={classes.accordion__item}
      onClick={() => setIsActive(!isActive)}
    >
      <div className={classes.accordion__item__inner}>
        <h2 className={classes.accordion__item__title}>{title}</h2>
        <p className={classes.accordion__item__subtitle}>{subtitle}</p>
        <div className={classes.accordion__item__desktop}>
          <p className={classes.accordion__item__price}>{price}</p>
          <ArrowIcon className={classes.accordion__item__arrow} />
        </div>
      </div>
      {isActive && (
        <div className={classes.accordion__item__content}>{description}</div>
      )}
    </div>
  );
};

export default Accordion;
